import MUIDataTable from "mui-datatables";
import React, { useState } from "react";
import DialogoConfirmacion from "./DialogoConfirmacion";
import ModalModificar from "./ModalModificar";

const TablaClases = ({ datosTabla, data3, origen }) => {
  const [itemClicked, setItemClicked] = useState(undefined);
  const columns = [
    {
      name: "codigo",
      label: "Código",
      options: {
        filter: true,
        display: true,
      },
    },

    {
      label: "Nombre ",
      name: "nombre",
      options: {
        filter: true,
        display: true,
      },
    },

    {
      name: "origen",
      label: "Origen ",
      options: {
        filter: false,
        display: true,
      },
    },

    {
      name: "esformato",
      label: "¿Es Formato? ",
      options: {
        filter: true,
        display: true,
      },
    },

    {
      name: "indexar",
      label: "Indexar ",
      options: {
        filter: true,
        display: true,
      },
    },

    {
      name: "id",
      label: " ",
      options: {
        filter: false,
        display: true,
        sort: false,
        viewColumns: false,
        customBodyRenderLite: (value) => (
          <DialogoConfirmacion id={datosTabla[value][6]} />
        ),
      },
    },
  ];

  const options = {
    expandableRowsOnClick: true,

    responsive: "standard",
    searchPlaceholder: "Buscar ",
    tableBodyHeight: "estándar",
    tableBodyMaxHeight: "estándar",
    onRowsPerPageChange: 10,
    print: false,
    viewColumns: true,
    filter: false,
    selectableRows: "none",
    download: false,
    onRowClick: (e, meta) => {
      handleOpenModal(meta.dataIndex);
    },

    textLabels: {
      body: {
        noMatch: "Registros no encontrados",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
        sortable: true,
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Registros por página:",
        displayRows: "de",
        onPageChange: true,
      },
      toolbar: {
        search: "Buscar",
        viewColumns: "Ver columnas",
        downloadCsv: "Descargar",
      },

      viewColumns: {
        title: "Mostrar columnas",
      },

      TableHead: {
        root: {
          sortable: false,
          color: "white",
          backgroundColor: "#007B7B",
        },
      },
    },
  };

  const handleOpenModal = (index) => {
    setItemClicked(datosTabla[index]);
  };

  const handleDeleteItemClicked = () => {
    setItemClicked(undefined);
  };

  return (
    <React.Fragment>
      <MUIDataTable data={datosTabla} columns={columns} options={options} />
      {itemClicked && (
        <ModalModificar
          onHide={handleDeleteItemClicked}
          nombre={itemClicked[1]}
          Dias={itemClicked[5]}
          origen={itemClicked[2]}
          id={itemClicked[6]}
          codigo={itemClicked[0]}
          data3={data3}
          listaOrigenes={origen}
          index={itemClicked[4]}
          formato={itemClicked[3]}
        />
      )}
    </React.Fragment>
  );
};

export default TablaClases;
